import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Text,
} from "recharts";
import "../StackedBarChart/StackedBarChart.css";

const data = [
  { name: "Mon", volume: 1200, orders: 800, profit: 600, loss: 300 },
  { name: "Tue", volume: 1500, orders: 900, profit: 700, loss: 200 },
  { name: "Wed", volume: 1800, orders: 1100, profit: 900, loss: 400 },
  { name: "Thu", volume: 1700, orders: 1000, profit: 800, loss: 300 },
  { name: "Fri", volume: 2000, orders: 1200, profit: 1000, loss: 500 },
  { name: "Sat", volume: 1600, orders: 950, profit: 750, loss: 350 },
  { name: "Sun", volume: 1400, orders: 850, profit: 650, loss: 300 },
];

const CustomBarWithRadius = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 5; // Rounded corner radius
  return (
    <path
      d={`M${x},${y + radius} 
         a${radius},${radius} 0 0,1 ${radius},-${radius} 
         h${width - radius * 2} 
         a${radius},${radius} 0 0,1 ${radius},${radius} 
         v${height - radius} 
         h-${width} 
         Z`}
      fill={fill}
    />
  );
};

const StackedBarChart = () => {
  return (
    <>
      <section className="section">
        <div className="stacked-container">
          <div className="stacked-header">
            <h1>
              Weekly Performance Overview
              {/* : Trading Volume, Orders, Profit, and Loss Trends */}
            </h1>
          </div>

          <div className="stacked-parent">
            <div className="stacked-count-wrapper">
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#8197f8" }}
                ></i>{" "}
                Volume
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#a5bcfc" }}
                ></i>{" "}
                Orders
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#c7d7fe" }}
                ></i>{" "}
                Profit
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#dcdcdc" }}
                ></i>{" "}
                Loss
              </div>
            </div>

            <div className="stacked-chart-container">
              <ResponsiveContainer height={330}>
                <ComposedChart
                  data={data}
                  margin={{ top: 10, right: 10, left: 10, bottom: 30 }}
                >
                  <CartesianGrid
                    stroke="#d6d6d6"
                    strokeDasharray="0 0"
                    horizontal={true}
                    vertical={false}
                  />
                  <XAxis
                    dataKey="name"
                    tick={{ fontSize: 14, fill: "#999" }} // Set tick style
                    label={{
                      value: "Days of the Week",
                      position: "insideLeft",
                      offset: 0,
                      style: { fontSize: "14px", fill: "#999" }, // Set label style
                      dy: 30,
                    }}
                  />
                  <YAxis
                    tick={{ fontSize: 14, fill: "#999" }} // Set tick style
                    label={{
                      value: "Count (Units)",
                      angle: -90,
                      position: "insideBottom",
                      offset: 40,
                      style: { fontSize: "14px", fill: "#999" }, // Set label style
                      dx: -20,
                    }}
                  />
                  <Tooltip
                    labelStyle={{
                      fontWeight: "bold",
                      fontSize: "14px", // Updated to match the uniform size
                      color: "#000", // Updated to match font color
                    }}
                    itemStyle={{
                      color: "#999", // Updated to match font color
                      fontSize: "14px", // Updated to match the uniform size
                    }}
                    wrapperStyle={{
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                  />
                  <Bar
                    dataKey="volume"
                    stackId="a"
                    fill="#8197f8"
                    barSize={window.innerWidth < 600 ? 25 : 30}
                  />
                  <Bar
                    dataKey="orders"
                    stackId="a"
                    fill="#a5bcfc"
                    barSize={window.innerWidth < 600 ? 25 : 30}
                  />
                  <Bar
                    dataKey="profit"
                    stackId="a"
                    fill="#c7d7fe"
                    barSize={window.innerWidth < 600 ? 25 : 30}
                  />
                  <Bar
                    dataKey="loss"
                    stackId="a"
                    fill="#dcdcdc"
                    barSize={window.innerWidth < 600 ? 25 : 30}
                    shape={<CustomBarWithRadius />}
                  />
                </ComposedChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StackedBarChart;
